var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-col-12 p-card relative page-container"},[_c('router-view',{attrs:{"loading":_vm.loading},on:{"loadingChange":_vm.loadingChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }